export const methodPayEs = {
  card: 'Tarjeta',
  paypal: 'Paypal',
  cash: 'Depósito',
  spei: 'Depósito'
}

export const statusPayEs = {
  payed: 'Pagado',
  pending: 'Pendiente',
  sent: 'Enviado',
  cancelled: 'Cancelado'
}

export const cfdiCollection = {
  1: 'G01- Adquisición de mercancías',
  2: 'G03 - Gastos en general',
  3: 'D02 - Gastos médicos por incapacidad o discapacidad',
  4: 'D01 - Honorario médicos, dentales y gastos hospitalarios',
  5: 'P01 - Por definir'
}

export const methodPayAppointment = {
  cash: 'Efectivo (de preferencia llevar monto exacto)',
  card: 'Tarjeta de Crédito/ Débito (terminal en el laboratorio)',
  spei: 'Transferencia bancaria',
  paypal: 'Paypal'
}

export const methodPayAppointmentAdmin = {
  cash: 'Efectivo ',
  card: 'Tarjeta de Crédito/ Débito',
  spei: 'Transferencia bancaria',
  paypal: 'Paypal'
}

export const conceptbill = {
  1: 'Análisis Clínicos en General',
  2: 'Estudios desglosados'
}
